import { AutocompleteModel } from '../models/autocomplete/autocomplete.model';
import { AutocompleteStylingModel } from '../models/autocomplete/autocomplete-styling.model';

export const /** @type {?} */ AutocompleteTemplates = {
  defaultTemplate: {
    property: new AutocompleteModel({
      display: true,
      disable: false,
      displayField: '',
      source: [],
      serverUrl: '',
      useChips: false,
      chipsSelected: 'multiple',
      chipsReadOnly: false,
      multiselection: false,
      uniqueSelected: true,
      stayOpenedOnClick: false,
      highlighting: false,
      cache: false,
      prefetch: false,
      delay: 250
    })
  },
  contactsTemplate: {
    property: new AutocompleteModel({
      display: true,
      disable: false,
      displayField: '',
      source: [],
      serverUrl: '',
      useChips: true,
      chipsSelected: 'multiple',
      chipsReadOnly: false,
      multiselection: false,
      uniqueSelected: true,
      stayOpenedOnClick: false,
      highlighting: false,
      cache: false,
      prefetch: false,
      delay: 250
    }),
    style : new AutocompleteStylingModel({
      searchContainer: {class: 'cf-contacts-template'},
      inputContainer: {class: 'cf-contacts-template'},
    })
  }
}
